import { watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import { useClientFormFields } from '../composables/useClientFormFields';
import { useClientSaver } from '../composables/useClientSaver';
import { useCurrentClient } from '../composables/useCurrentClient';

export function useClientForm() {
  const router = useRouter();
  const route = useRoute();

  const { currentClient } = useCurrentClient();
  const { form, handleSubmit, errors, populateFormWithClientData, resetForm } =
    useClientFormFields();
  const { saveClient, isPending } = useClientSaver();

  function redirectToNewClientView() {
    router.push({
      name: 'NewClientView',
      params: {
        calculatorId: route.params.calculatorId,
      },
    });
  }

  watch(
    [route, currentClient],
    () => {
      if (!currentClient.value) {
        redirectToNewClientView();
        return;
      }

      populateFormWithClientData(currentClient.value);
    },
    {
      immediate: true,
    }
  );

  const handleAddClient = handleSubmit(() => {
    if (Object.keys(errors.value).length > 0) return;

    saveClient({ ...form });
  });

  return {
    isPending,
    form,
    handleAddClient,
    errors,
    resetForm,
  };
}
